<template>
	<div class="home">
		<img
			alt="downloadapp"
			src="@/assets/techSupport.jpg"
		/>
		<div class="infos">
			<span>欢迎使用乐象有品APP，如您在使用中遇到任何问题，可联系客服获取技术支持</span>
		</div>
		<div class="contact-customer-service-panel">
			<a
				type="button"
				href="tel:15220698716"
			>联系客服</a>
		</div>
		<Copyright />
	</div>
</template>

<script>
import Copyright from "@/components/Copyright.vue";

export default {
	name: "TechSupport",
	components: {
		Copyright
	},
	data() {
		return {};
	}
};
</script>

<style lang="scss" scoped>
.home {
	position: relative;
	img {
		text-align: center;
		width: 48.9vh;
		height: 100vh;
	}
	.infos {
		position: absolute;
		left: 50%;
		width: 325px;
		padding: 12px;
		background: #fff;
		border-radius: 6px;
		box-shadow: 0 2px 100px rgba(127, 127, 127, 0.6);
		transform: translateX(-50%);
		line-height: 22px;
		font-size: 15px;
		animation: 0.6s showInfo both;

		@keyframes showInfo {
			0% {
				top: -100px;
			}
			100% {
				top: 70%;
			}
		}
		.contact-detail {
			color: #1890ff;
			text-decoration: underline;
		}
	}
	.contact-customer-service-panel {
		position: absolute;
		bottom: 10%;
		left: 50%;
		transform: translateX(-50%);
		a {
			display: block;
			line-height: 50px;
			width: 260px;
			height: 50px;
			color: #fff;
			background-image: linear-gradient(to right, #fd3b45, #ff6e51);
			border-radius: 4px;
			font-size: 18px;
		}
	}
}

@media screen and (max-width: 450px) {
	.home {
		position: relative;
		img {
			width: 100vw;
			height: 204.53vw;
		}
	}
}
</style>